'use client';

import { useFooterData } from '@/lib/hooks/useFooter';
import FooterServer from './FooterServer';

interface FooterClientProps {
  dict: any;
  currentLang: string;
}

export function FooterClient({ dict, currentLang }: FooterClientProps) {
  const { data, loading, error } = useFooterData(dict);

  if (loading) {
    return (
      <footer className="py-16" style={{ backgroundColor: '#203F72' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="space-y-4">
                <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
                <div className="space-y-2">
                  {[1, 2, 3].map((j) => (
                    <div key={j} className="h-4 bg-gray-200 rounded animate-pulse"></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </footer>
    );
  }

  if (error || !data) {
    return (
      <footer className="py-16" style={{ backgroundColor: '#203F72' }}>
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-500">Footer content unavailable</p>
        </div>
      </footer>
    );
  }

  return <FooterServer initialData={data} dict={dict} currentLang={currentLang} />;
}

export default FooterClient;
